import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { storage, db, auth } from '../Firebase/Firebase.js';
import { getFirestore, setDoc, doc, getDoc, collection, query, where, getDocs, addDoc, updateDoc } from 'firebase/firestore';
import './PlataformaReserva.css';
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import FloatingWhatsApp from '../Components/whatsappbutton.js';
import LoadingScreen from '../Components/loading.js';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import QRCodeGenerator from '../Components/QRcodeGenerator.js';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion.js';

export default function DetalleEspacio() {
    const { IdEspacio } = useParams();
    const navigate = useNavigate();
    const [espacio, setEspacio] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fechaSeleccionada, setFechaSeleccionada] = useState('');
    const [horasDisponibles, setHorasDisponibles] = useState([]);
    const [horaInicio, setHoraInicio] = useState('');
    const [horaFin, setHoraFin] = useState('');
    const [bloqueos, setBloqueos] = useState([]);
    const [resenas, setResenas] = useState([]);
    const [qrCodeModalIsOpen, setQrCodeModalIsOpen] = useState(false);
    const [usuario, setUsuario] = useState(null);
    const [costoTotal, setCostoTotal] = useState(0);
    const [cantidadPersonas, setCantidadPersonas] = useState(1);
    const [disponibilidadHoras, setDisponibilidadHoras] = useState({});
    const [reservaId, setReservaId] = useState(null);
    useEffect(() => {
        // Obtener el usuario actual logueado
        const user = auth.currentUser;
        if (user) {
            async function fetchUsuario() {
                const userRef = doc(db, 'usuarios', user.uid);
                const docSnap = await getDoc(userRef);
                if (docSnap.exists()) {
                    setUsuario({ id: docSnap.id, ...docSnap.data() });
                }
            } fetchUsuario();
        }

    }, []);

    useEffect(() => {
        async function fetchEspacio() {
            const ref = doc(db, 'espacios', IdEspacio);
            const snap = await getDoc(ref);
            if (snap.exists()) {
                console.log(snap.data());
                setEspacio({ IdEspacio, ...snap.data() });
            }
        }
        fetchEspacio();
    }, [IdEspacio]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (espacio?.Imagenes?.length) {
                setCurrentIndex((prev) => (prev + 1) % espacio.Imagenes.length);
            }
        }, 3000);
        return () => clearInterval(interval);
    }, [espacio]);

    useEffect(() => {
        if (!fechaSeleccionada || !espacio) return;

        const obtenerReservas = async () => {
            const q = query(
                collection(db, 'reservas'),
                where('IdEspacio', '==', espacio.IdEspacio),
                where('fechaInicio', '==', fechaSeleccionada)
            );
            const querySnapshot = await getDocs(q);

            const rangos = querySnapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    inicio: data.horaInicio,
                    fin: data.horaFinal,
                    cantidad: data.cantidadPersonas || 1
                };
            });


            if (espacio.isCoworking && espacio.CapacidadMax) {
                const disponibilidad = {};
                const horas = generarHoras();

                horas.forEach(h => {
                    disponibilidad[h] = espacio.CapacidadMax;
                });

                rangos.forEach(({ inicio, fin, cantidad }) => {
                    const inicioHora = parseInt(inicio.split(":")[0]);
                    const finHora = parseInt(fin.split(":")[0]);

                    for (let h = inicioHora; h < finHora; h++) {
                        const horaStr = `${h.toString().padStart(2, '0')}:00`;
                        disponibilidad[horaStr] = (disponibilidad[horaStr] || espacio.CapacidadMax) - cantidad;
                    }
                });
                setBloqueos(rangos);

                setDisponibilidadHoras(disponibilidad);
            }

        };

        obtenerReservas();
    }, [fechaSeleccionada, espacio]);

    useEffect(() => {
        const obtenerResenas = async () => {
            if (!espacio) return;
            const q = query(
                collection(db, 'reseñas'),
                where('idEspacio', '==', espacio.IdEspacio)
            );
            const querySnapshot = await getDocs(q);
            const data = querySnapshot.docs.map(doc => doc.data());
            setResenas(data);
        };
        obtenerResenas();
    }, [espacio]);

    const seleccionarHora = (hora) => {

        if (!horaInicio || (horaInicio && horaFin)) {
            setHoraInicio(hora);
            setHoraFin('');

        } else if (hora > horaInicio) {
            setHoraFin(hora);

        } else {
            setHoraInicio(hora);
            setHoraFin('');

        }

    };
    useEffect(() => {
        if (horaInicio && horaFin) { // Aquí verificamos si "algo" tiene un valor
            calcularCosto();
        }
    }, [horaInicio, horaFin, cantidadPersonas]);

    const estaOcupada = (hora) => {
        return bloqueos.some(({ inicio, fin }) => hora >= inicio && hora < fin);
    };

    const estaEnRango = (hora) => {
        return horaInicio && horaFin && hora >= horaInicio && hora <= horaFin;
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1) % espacio.Imagenes.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev - 1 + espacio.Imagenes.length) % espacio.Imagenes.length);
    };

    const getVisibleImages = () => {
        if (!espacio) return [];
        const total = espacio.Imagenes.length;
        const prev = (currentIndex - 1 + total) % total;
        const next = (currentIndex + 1) % total;
        return [prev, currentIndex, next];
    };

    const generarHoras = () => {
        if (!espacio?.horaApertura || !espacio?.horaCierre) return [];
        const inicio = parseInt(espacio.horaApertura.split(":")[0]);
        const fin = parseInt(espacio.horaCierre.split(":")[0]);
        const horas = [];
        for (let h = inicio; h <= fin; h++) {
            const hora = h.toString().padStart(2, '0') + ':00';
            horas.push(hora);
        }
        return horas;
    };

    // Función de reserva
    const reservar = async () => {
        calcularCosto();
        if (!usuario) {
            // Muestra el Toast solo si el usuario no está logueado
            toast.error(
                <div style={{ padding: '10px 20px', color: '#fff', fontSize: '16px' }}>
                    <p style={{ margin: 0, fontWeight: 'bold' }}>¡Ops! Necesitas loguearte para realizar una reserva.</p>
                    <button
                        onClick={handleLogin}
                        style={{
                            padding: '12px 25px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '15px',
                            cursor: 'pointer',
                            marginTop: '10px',
                            fontSize: '16px',
                            boxShadow: '0 4px 6px rgba(0, 123, 255, 0.2)',
                            transition: 'background-color 0.3s ease, transform 0.3s ease',
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                    >
                        Ingresar
                    </button>
                </div>,
                {
                    position: "top-center",
                    autoClose: 8000,  // Se cierra automáticamente después de 8 segundos
                    closeOnClick: true, // Se puede cerrar con clic
                    draggable: true,
                    theme: "colored",

                    style: {
                        backgroundColor: '#fbbf24', // Rojo para un mensaje de error
                        color: '#ffffff', // Blanco para el texto
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        marginTop: '35px',
                    },
                }
            );



        } else {
            const coins = Number(usuario.coins);
            if (isNaN(coins) || coins < costoTotal) {
                console.log('Coins insuficientes');
                toast.error(
                    <div style={{ padding: '10px 20px', color: '#fff', fontSize: '16px' }}>
                        <p style={{ margin: 0, fontWeight: 'bold', color: '#fff', fontSize: '16px' }}>
                            ¡Ups! 😕 Tu saldo de <strong>coins</strong> es insuficiente para completar la reserva.
                            La reserva de tu espacio tienen un costo de
                            <strong style={{ color: '#f4f4f4' }}>{` ${costoTotal} coins`}</strong>.<br />
                            ¡Recarga tu saldo y disfruta de tu experiencia!
                        </p>
                        <button
                            onClick={handleRecargarCoins}
                            style={{
                                padding: '12px 25px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '15px',
                                cursor: 'pointer',
                                marginTop: '10px',
                                fontSize: '16px',
                                boxShadow: '0 4px 6px rgba(0, 123, 255, 0.2)',
                                transition: 'background-color 0.3s ease, transform 0.3s ease',
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                        >
                            Recargar
                        </button>
                    </div>,
                    {
                        position: "top-center",
                        autoClose: 8000,  // Se cierra automáticamente después de 8 segundos
                        closeOnClick: true, // Se puede cerrar con clic
                        draggable: true,
                        theme: "colored",

                        style: {
                            backgroundColor: '#fbbf24', // Rojo para un mensaje de error
                            color: '#ffffff', // Blanco para el texto
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            marginTop: '35px',
                        },
                    }
                );
            } else {
                if (espacio.isCoworking && espacio.cantidad && horaInicio && horaFin) {
                    const hInicio = parseInt(horaInicio.split(":")[0]);
                    const hFin = parseInt(horaFin.split(":")[0]);

                    for (let h = hInicio; h < hFin; h++) {
                        const horaStr = `${h.toString().padStart(2, '0')}:00`;
                        const disponible = disponibilidadHoras[horaStr] || 0;
                        if (cantidadPersonas > disponible) {
                            toast.error(`No hay suficientes espacios disponibles a las ${horaStr}. Máximo disponible: ${disponible}`);
                            return;
                        }
                    }
                }
                guardarReserva();
            }
        }



        // Si el usuario está logueado, continuar con la reserva
        try {
            // Lógica de reserva aquí
        } catch (error) {
            console.error("Error al realizar la reserva:", error);
        }
    };
    const calcularCosto = () => {
        if (horaInicio && horaFin && espacio) {
            const inicio = new Date(`1970-01-01T${horaInicio}:00`);
            const fin = new Date(`1970-01-01T${horaFin}:00`);
            const diferenciaEnMilisegundos = fin - inicio;
            const diferenciaEnHoras = diferenciaEnMilisegundos / (1000 * 60 * 60);

            let costo = diferenciaEnHoras * espacio.costoEspHoraCoins;

            if (espacio.isCoworking && cantidadPersonas) {
                costo *= cantidadPersonas;
            }

            setCostoTotal(costo);
        }
    };

    // Función para redirigir al login
    const handleLogin = () => {
        localStorage.setItem('reservation', 'true');
        localStorage.setItem('reservationUrl', window.location.href);
        navigate('/login');  // Cambia esta ruta a la ruta de tu login
    };

    const handleRecargarCoins = () => {
        localStorage.setItem('reservationCoins', 'true');
        localStorage.setItem('reservationCoinsUrl', window.location.href);
        navigate('/coin-purchase');
    };

    const guardarReserva = async () => {
        const reservationData = {
            fechaInicio: fechaSeleccionada,
            horaInicio: horaInicio,
            horaFinal: horaFin,
            costoReserva: costoTotal,
            idUser: usuario.id,
            IdEspacio: espacio.IdEspacio,
            reseñaRealizada: false,
            calUsers: false,
            fechaDeReserva: new Date(),
            cantidadPersonas: cantidadPersonas

        };
        try {
            const userRef = doc(db, 'usuarios', usuario.id);
            await updateDoc(userRef, {
                coins: usuario.coins - costoTotal,
            });
            const docRef = await addDoc(collection(db, 'reservas'), reservationData);
            const reservaId = docRef.id; // Aquí capturas el ID generado
            setReservaId(reservaId);
            toast.success(
                <div style={{ padding: '15px 25px', color: '#fff', fontSize: '18px', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontWeight: 'bold', color: 'black', fontSize: '18px' }}>
                        🎉 ¡Reserva Confirmada! 🎉
                        <br />
                        ¡Felicidades! Tu espacio está reservado con éxito.
                        <br />
                        ¡Prepárate para disfrutar de la mejor experiencia!
                    </p>
                    <button
                        onClick={setQrCodeModalIsOpen(true)}
                        style={{
                            padding: '12px 30px',
                            backgroundColor: '#c7ffc0',
                            color: 'black',
                            border: 'none',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            marginTop: '15px',
                            fontSize: '16px',
                            boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)',
                            transition: 'background-color 0.3s ease, transform 0.3s ease',
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#badfb6'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#d4ffcf'}
                    >
                        ¡Empecemos !
                    </button>
                </div>,
                {
                    position: "top-center",
                    autoClose: 8000,  // Se cierra automáticamente después de 8 segundos
                    closeOnClick: true, // Se puede cerrar con clic
                    draggable: true,
                    theme: "colored",
                    style: {
                        backgroundColor: '#d9f6d5', // Verde brillante para éxito
                        color: '#ffffff', // Blanco para el texto
                        borderRadius: '12px',
                        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)',
                        marginTop: '35px',
                    },
                    onClose: () => {
                        setQrCodeModalIsOpen(true); // Esta es la acción que se ejecuta cuando el toast se cierra
                    }
                }
            );

        } catch (error) {
            console.error("Error al guardar la reserva:", error);
        }
    }

    useEffect(() => {
        if (fechaSeleccionada) {
            setHorasDisponibles(generarHoras());
        }
    }, [fechaSeleccionada, espacio]);
    const [isDarkMode, setIsDarkMode] = useState(() => {
        try {
            // Intentamos leer valor guardado en localStorage
            const saved = localStorage.getItem('darkMode');
            if (saved !== null) {
                const parsed = JSON.parse(saved);
                if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
            }
        } catch (error) {
            // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
            console.warn('Error leyendo localStorage darkMode:', error);
        }

        // Detectar modo oscuro sistema solo si está disponible window.matchMedia
        const prefersDark = typeof window !== 'undefined' && window.matchMedia
            ? window.matchMedia('(prefers-color-scheme: dark)').matches
            : false;

        // Detectar hora nocturna (7pm a 6am)
        const hour = new Date().getHours();
        const isNight = hour >= 19 || hour < 6;

        // Retorna true o false seguro
        return prefersDark || isNight;
    });

    // Cargar el tema al inicio (localStorage, sistema u hora)
    useEffect(() => {
        const savedTheme = localStorage.getItem('darkMode');
        if (savedTheme !== null) {
            setIsDarkMode(JSON.parse(savedTheme));
        } else {
            // Detecta modo oscuro sistema
            const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

            // Detecta modo oscuro por hora (7pm - 6am)
            const hour = new Date().getHours();
            const isNight = hour >= 19 || hour < 6;

            setIsDarkMode(prefersDark || isNight);
        }
    }, []);

    // Guardar la preferencia y aplicar clase al body
    useEffect(() => {
        localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
        document.body.classList.toggle('dark-mode', isDarkMode);
    }, [isDarkMode]);

    // Función para cambiar el modo
    const toggleDarkMode = () => setIsDarkMode(!isDarkMode);
    const maxPersonasPermitidas = horaInicio && horaFin
        ? Math.min(
            ...Object.entries(disponibilidadHoras)
                .filter(([hora]) => hora >= horaInicio && hora < horaFin)
                .map(([_, capacidad]) => capacidad)
        )
        : 0;
    if (!espacio) return <LoadingScreen />;

    return (
        <>
            <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />

            <FloatingWhatsApp />
            <ToastContainer /> {/* Aquí se coloca el ToastContainer para que se rendericen los toasts */}

            <div className="espacio-container">
                <div className="espacio-header">
                    <h1 className="espacio-titulo">{espacio.NombreEspacio}</h1>
                    <p className="espacio-subtitulo">{espacio.categoriaEspacio} · Capacidad {espacio.CapacidadMin} - {espacio.CapacidadMax} personas</p>
                </div>
                <div className="espacio-carrusel-multiple">
                    <button className="carrusel-btn carrusel-prev" onClick={handlePrev}>‹</button>
                    <div className="carrusel-center">
                        {getVisibleImages().map((i, index) => (
                            <div key={i} className={`carrusel-item-multi ${index === 1 ? 'active' : 'side'}`}>
                                <img src={espacio.Imagenes[i]} alt={`Imagen ${i + 1}`} className="espacio-img-multiple" />
                            </div>
                        ))}
                    </div>
                    <button className="carrusel-btn carrusel-next" onClick={handleNext}>›</button>
                </div>

                <div className="espacio-content2">
                    {/* Detalles del espacio */}
                    <div className="espacio-info-detalle" style={{
                        borderColor: `${espacio.Color}`,
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        boxShadow: `0 4px 8px rgba(0, 0, 0, 0.1)`
                    }}>                        <p><strong>Accesorios:</strong> {espacio.Accesorios}</p>
                        <p><strong>Descripción:</strong> {espacio.DescripcionEspacio}</p>

                    </div>


                    <div className="reserva-sticky">
                        <div className="reserva-card">
                            <h3>Selecciona fecha y horario</h3>
                            <div className="reserva-fechas">
                                <div>
                                    <label>FECHA</label>
                                    <input
                                        type="date"
                                        value={fechaSeleccionada}
                                        min={new Date().toISOString().split('T')[0]}
                                        onChange={(e) => {
                                            const hoy = new Date().toISOString().split('T')[0];
                                            const valor = e.target.value;
                                            setFechaSeleccionada(valor < hoy ? hoy : valor);
                                        }}
                                    />
                                </div>
                            </div>
                            {horasDisponibles.length > 0 && (
                                <div className="reserva-horas">
                                    <label>HORARIO DISPONIBLE</label>
                                    <div className="horas-scroll">
                                        {horasDisponibles.map((hora, idx) => {
                                            const activo = hora === horaInicio || hora === horaFin;
                                            const enRango = estaEnRango(hora);
                                            const esHoy = fechaSeleccionada === new Date().toISOString().split('T')[0];
                                            const ahora = new Date();
                                            const horaObj = new Date(`${fechaSeleccionada}T${hora}`);
                                            const esPasada = esHoy && horaObj <= ahora;
                                            const ocupada = estaOcupada(hora);
                                            let bloquear;

                                            if (espacio.isCoworking) {
                                                const disponible = disponibilidadHoras?.[hora] ?? 0;
                                                bloquear = esPasada || disponible <= 0;
                                            } else {
                                                bloquear = esPasada || ocupada;
                                            }

                                            return (
                                                <div
                                                    key={idx}
                                                    className={`hora-bloque ${activo ? 'activo' : ''} ${enRango ? 'rango' : ''} ${bloquear ? 'bloqueada' : ''}`}
                                                    onClick={() => {
                                                        if (!bloquear) seleccionarHora(hora);
                                                    }}
                                                    style={{ pointerEvents: bloquear ? 'none' : 'auto' }}
                                                >
                                                    {hora}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            {
                                espacio.descuentoXPersona && (<div className="reserva-huespedes">
                                    <label>USUARIOS</label>
                                    <select>
                                        {Array.from({ length: espacio.CapacidadMax }, (_, i) => (
                                            <option key={i}>{i + 1} usuario{i !== 0 ? 's' : ''}</option>
                                        ))}
                                    </select>
                                </div>)
                            }
                            {
                                <div>
                                    {fechaSeleccionada && horaInicio && horaFin && (
                                        <div className="reserva-huespedes">
                                            Reserva para el día {fechaSeleccionada} de {horaInicio} a {horaFin}
                                        </div>
                                    )}
                                </div>

                            }
                            {espacio.isCoworking && (
                                <div className="reserva-huespedes">
                                    <label>PERSONAS</label>
                                    {horaInicio && horaFin ? (
                                        <>
                                            {(() => {
                                                // Obtener mínimo disponible en el rango horario
                                                const disponiblePorHoras = Object.entries(disponibilidadHoras)
                                                    .filter(([hora]) => hora >= horaInicio && hora < horaFin)
                                                    .map(([_, capacidad]) => capacidad);

                                                const minDisponible = Math.min(...disponiblePorHoras, espacio.CapacidadMax);

                                                return (
                                                    <>
                                                        <input
                                                            type="number"
                                                            min={1}
                                                            max={minDisponible}
                                                            value={cantidadPersonas}
                                                            onChange={(e) => {
                                                                const nuevaCantidad = parseInt(e.target.value);
                                                                const ajustado = Math.min(nuevaCantidad, minDisponible);
                                                                setCantidadPersonas(
                                                                    isNaN(ajustado) || ajustado < 1 ? 1 : ajustado
                                                                );
                                                            }}
                                                        />
                                                        <small style={{ color: '#666' }}>
                                                            Disponible en este horario: {minDisponible} persona(s)
                                                        </small>
                                                    </>
                                                );
                                            })()}
                                        </>
                                    ) : (
                                        <p style={{ color: '#999' }}>Selecciona primero un rango horario</p>
                                    )}
                                </div>
                            )}


                            <button
                                className="reservar-btn-full"
                                onClick={reservar}
                                disabled={
                                    !fechaSeleccionada ||
                                    !horaInicio ||
                                    !horaFin ||
                                    (espacio.isCoworking && (!cantidadPersonas || cantidadPersonas < 1))
                                }
                            >
                                Reservar
                            </button>
                        </div>
                    </div>
                </div>

                <div className="espacio-mapa">
                    <iframe
                        title="mapa"
                        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyB7Sx1jXG9YS5c7Iy-qxOEfkECMh7syeqg&q=${espacio.latitud},${espacio.longitud}`}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>

                {resenas.length > 0 && (
                    <div className="resenas-section">
                        <h2>★ {(
                            resenas.reduce((sum, r) => sum + r.calificacion, 0) / resenas.length
                        ).toFixed(2)} · {resenas.length} reseñas</h2>

                        <div className="resena-resumen">
                            <div className="resena-categoria">
                                <p>Valoración general</p>
                                <span>5</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Limpieza</p>
                                <span>5.0</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Exactitud</p>
                                <span>5.0</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Check-in</p>
                                <span>4.9</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Comunicación</p>
                                <span>4.8</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Ubicación</p>
                                <span>4.9</span>
                            </div>
                            <div className="resena-categoria">
                                <p>Precio</p>
                                <span>4.6</span>
                            </div>
                        </div>

                        <div className="resenas-list">
                            {resenas.map((res, idx) => (
                                <div className="resena-item" key={idx}>
                                    <div className="resena-usuario">
                                        <img src={res.foto} alt="Usuario" />
                                        <div>
                                            <strong>{res.nombreUsuario}</strong>
                                        </div>
                                    </div>
                                    <p className="resena-calificacion">{'★'.repeat(res.calificacion)}</p>
                                    <p className="resena-texto">{res.Reseña}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            {usuario && (
                <QRCodeGenerator
                    isOpen={qrCodeModalIsOpen}
                    onClose={() => {
                        setQrCodeModalIsOpen(false);
                        navigate('/reservasRealizadas');
                    }}
                    userName={`${usuario.name} ${usuario.lastname}`}
                    espacio={espacio?.NombreEspacio ?? ''}
                    reservationDate={fechaSeleccionada}
                    startTime={horaInicio}
                    endTime={horaFin}
                    reservaId={reservaId} // NUEVO
                    idUser={usuario.id}   // NUEVO
                    idEspacio={espacio?.IdEspacio}
                />

            )}

            <Footer />
        </>
    );
}
